<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phiếu chuyển mục đích sử dụng</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button @click="create" class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian tạo"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.billNumber"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã phiếu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.reasonUsageChange"
              :options="Config.getSearch(Config.reasonUsageChange)"
              placeholder="Lý do"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.inventoryIdImport"
              :options="Config.getSearch(optionInventory)"
              placeholder="Tên kho"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="Config.getSearch(Config.statusImportWarehouse)"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.creatorId"
              :options="Config.getSearch(dataManager)"
              placeholder="Người tạo"
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <p>{{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(creator)="data">
                <p>{{ data.item.userCreator ? data.item.userCreator.name : '' }}</p>
              </template>
              <template #cell(reason)="data">
                <p>{{ data.item.reasonUsageChange | transformData(Config.reasonUsageChange) }}</p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="data.item.status">
                  {{ data.item.status | transformData(Config.statusImportWarehouse) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detail(data.item)" class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { StaffService } from '@/services/staff.service'
  import moment from 'moment'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'billNumber', label: 'Mã phiếu', thStyle: 'min-width: 250px' },
    { key: 'time', label: 'Thời gian', thStyle: 'min-width: 170px' },
    { key: 'quantityImport', label: 'SL thiết bị', thStyle: 'min-width: 150px' },
    { key: 'reason', label: 'Lý do', thStyle: 'min-width: 150px' },
    { key: 'creator', label: 'Người tạo', thStyle: 'min-width: 150px' },
    { key: 'status', label: 'Trạng thái', thStyle: 'min-width: 150px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'usage-change',
    data() {
      return {
        Config,
        fieldsTable,
        showLoading: false,
        filterTable: fieldsTable,
        tbLoading: false,
        lists: [],
        pagination: {
          total: 0,
        },
        search: {
          limit: 20,
          page: 1,
        },
        optionInventory: [],
        dataManager: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dateRange: {
          startDate: null,
          endDate: null,
        },
        localeData: Config.localeData,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.fetchData()
      StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
        .then(s => s.data?.map(s => ({ id: s.userId, text: `${s.name} - ${s.userName}` })) ?? [])
        .then(s => (this.dataManager = s))
      DeviceService.infoWarehouse()
        .then(s => s.data?.map(s => ({ id: s.id, text: s.name })) ?? [])
        .then(s => (this.optionInventory = s))
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    methods: {
      preareData() {
        const data = cloneDeep(this.search)
        for (const key in data) {
          if (data[key] === '0') delete data[key]
        }
        if (data.idDevice) {
          const dataAbbreviation = this.dataDevice.find(item => item.id === data.idDevice)
          data.abbreviation = dataAbbreviation.abbreviation
        }
        delete data.idDevice
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await DeviceService.getListUsageChange(params)
          if (response.code === 1000) {
            this.lists = response.data.orders
            this.pagination.total = response.data.count
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
          this.showFailMx(error.message)
        } finally {
          this.tbLoading = false
        }
      },
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.fetchData()
      },
      create() {
        this.$router.push({ path: '/usage-change/add' })
      },
      detail(data) {
        this.$router.push({ path: `/usage-change/${data.id}` })
      },
      transformDate() {
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
    },
  }
</script>

<style scoped>
  .ACTIVE {
    color: #fff;
    background-color: #28a745;
  }
</style>
